(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelux-faq"] && !Shopify.designMode) return;
  try {
    
/* FAQ repliable sous 750 px (réglage replier_mobile). Ordinateur : tout reste ouvert. */
(function () {
  var mobile = window.matchMedia('(max-width: 749px)');
  function reponse(b) {
    return document.getElementById(b.getAttribute('aria-controls'));
  }
  function regler(b, ouvert) {
    var a = reponse(b);
    if (!a) return;
    b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    a.hidden = !ouvert;
  }
  function etatInitial() {
    document.querySelectorAll('.pelux-faq--repliable .pelux-faq__bascule').forEach(function (b) {
      regler(b, !mobile.matches);
    });
  }
  function init() {
    etatInitial();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.pelux-faq--repliable .pelux-faq__bascule');
      if (!b || !mobile.matches) return;
      regler(b, b.getAttribute('aria-expanded') !== 'true');
    });
    if (mobile.addEventListener) mobile.addEventListener('change', etatInitial);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelux-final-cta"] && !Shopify.designMode) return;
  try {
    
/* Ajout direct du CTA final. ⚠️ Couplage avec sections/pelux-sticky-atc.liquid :
   tant que ce bloc est à l'écran, la classe `pelux-final-atc-en-vue` posée sur <body>
   retire la barre d'achat collante (règle CSS côté barre) — jamais deux sélecteurs de
   taille sur un même écran. Si ce script ne tourne pas, la classe n'est jamais posée
   et la barre garde son comportement normal. */
if (!customElements.get('pelux-final-atc')) {
  customElements.define(
    'pelux-final-atc',
    class extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-final-variants]').textContent);
        } catch (e) {
          return;
        }
        this.byId = {};
        this.variants.forEach((v) => {
          this.byId[v.id] = v;
        });
        this.sizeBtns = Array.from(this.querySelectorAll('.pelux-final__size'));
        this.addBtn = this.querySelector('[data-final-add]');
        this.aide = this.querySelector('[data-final-aide]');
        this.autre = this.querySelector('[data-final-autre]');
        this.taille = null;

        // Le guide n'existe que si le gabarit porte la section « Guide des tailles ».
        const guide = this.querySelector('.pelux-final__guide');
        if (guide && !document.getElementById('pelux-sg-dialog')) guide.hidden = true;

        this.sizeBtns.forEach((b) => b.addEventListener('click', () => this.choisir(b)));
        this.addBtn.addEventListener('click', () => this.ajouter());

        // Couleur visible : un toucher sur la miniature ramène au choix de couleur.
        this.couleur = this.querySelector('[data-final-couleur]');
        if (this.couleur) {
          this.couleur.addEventListener('click', () => {
            const index = parseInt(this.couleur.dataset.couleurIndex, 10) || 0;
            const choix =
              document.querySelectorAll('variant-selects .product-form__input')[index] ||
              document.querySelector('variant-selects');
            if (choix) choix.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }

        this.io = new IntersectionObserver(
          (entries) => {
            const vu = entries[0].isIntersecting;
            document.body.classList.toggle('pelux-final-atc-en-vue', vu);
            if (vu) this.rafraichir();
          },
          { threshold: 0 }
        );
        this.io.observe(this);
        this.rafraichir();

        // Taille cochée à l'arrivée (réglage du bloc Variantes, marqueur data-pelux-taille-defaut ;
        // harnais) : ce bloc reprend la taille du formulaire du haut — M d'office, puis celle que
        // le client y choisit. Une taille touchée ici tient jusqu'au prochain changement de taille
        // en haut de fiche. Sans ce réglage, rien ne change : la taille se choisit ici.
        this.tailleHaut = this.tailleDuHaut();
        if (this.tailleHaut) this.marquer(this.tailleHaut);
        this.suivreTaille = (e) => {
          if (!e.target || e.target.name !== 'id') return;
          const t = this.tailleDuHaut();
          if (t && t !== this.tailleHaut) {
            this.tailleHaut = t;
            this.rafraichir();
            this.marquer(t);
          }
        };
        document.addEventListener('change', this.suivreTaille);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.suivreTaille) document.removeEventListener('change', this.suivreTaille);
        document.body.classList.remove('pelux-final-atc-en-vue');
      }

      // Taille de la variante du formulaire du haut, seulement si le bloc Variantes a une
      // « Taille cochée à l'arrivée » ; sinon null (la taille se choisit ici).
      tailleDuHaut() {
        const vs = document.querySelector('variant-selects[data-pelux-taille-defaut]');
        const form = vs && document.getElementById('product-form-' + vs.dataset.section);
        const input = form && form.querySelector('[name="id"]');
        const v = input && this.byId[input.value];
        return v ? v.s : null;
      }

      // Coche une taille sans message (reprise du haut de fiche) ; une taille indisponible
      // dans ce coloris n'est pas cochée.
      marquer(taille) {
        const btn = this.sizeBtns.find((b) => b.dataset.size === taille);
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        this.taille = taille;
        this.sizeBtns.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.classList.remove('is-attention');
        this.dire('');
      }

      // Couleur = celle de la variante sélectionnée dans la zone d'achat (même lecture
      // que la barre collante : l'id de variante du formulaire produit).
      couleurCourante() {
        const input = document.querySelector(
          'form[data-type="add-to-cart-form"] [name="id"], product-info [name="id"], [name="id"]'
        );
        const cur = input && this.byId[input.value];
        return cur ? cur.c : this.variants[0] && this.variants[0].c;
      }

      variante(taille) {
        const c = this.couleurCourante();
        return this.variants.find((v) => v.c === c && v.s === taille) || null;
      }

      rafraichir() {
        const c = this.couleurCourante();
        if (this.autre && c) this.autre.textContent = c;
        if (this.couleur && c) {
          const v = this.variants.find((x) => x.c === c);
          const img = this.couleur.querySelector('img');
          if (v && v.img && img && img.getAttribute('src') !== v.img) img.setAttribute('src', v.img);
          const nom = this.couleur.getAttribute('aria-label').split(' : ')[0];
          this.couleur.setAttribute('aria-label', nom + ' : ' + c + '. Changer de ' + nom.toLowerCase());
        }
        this.sizeBtns.forEach((b) => {
          const v = this.variante(b.dataset.size);
          b.setAttribute('aria-disabled', v && v.av ? 'false' : 'true');
        });
      }

      dire(message) {
        if (this.aide) this.aide.textContent = message;
      }

      choisir(btn) {
        if (btn.getAttribute('aria-disabled') === 'true') {
          this.dire('Cette taille est indisponible dans ce coloris.');
          return;
        }
        this.taille = btn.dataset.size;
        this.sizeBtns.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.classList.remove('is-attention');
        this.dire('');
      }

      ajouter() {
        this.rafraichir();
        if (!this.taille) {
          this.dire('Choisis d’abord sa taille.');
          this.classList.remove('is-attention');
          void this.offsetWidth; // relance l'animation d'appel
          this.classList.add('is-attention');
          if (this.sizeBtns[0]) this.sizeBtns[0].focus({ preventScroll: true });
          return;
        }
        const v = this.variante(this.taille);
        if (!v || !v.av) {
          this.dire('Cette taille est indisponible dans ce coloris.');
          return;
        }
        // Même chemin que la barre collante : le tiroir se re-rend par renderContents(),
        // qui retire aussi `is-empty` (panier vide = nouveau visiteur).
        this.addBtn.setAttribute('disabled', '');
        const drawer = document.querySelector('cart-drawer');
        const sections =
          drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: v.id, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((res) => {
            this.addBtn.removeAttribute('disabled');
            if (res && res.status) {
              this.dire(res.description || res.message || 'L’ajout n’a pas abouti. Réessaie.');
              return;
            }
            this.dire('');
            if (drawer && res && res.sections && drawer.renderContents) {
              drawer.renderContents(res);
            } else {
              window.location = root + 'cart';
            }
          })
          .catch(() => {
            this.addBtn.removeAttribute('disabled');
            this.dire('L’ajout n’a pas abouti. Réessaie.');
          });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelux-sticky-atc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        // Repli explicite : sans l'ancre, la barre ne s'affichait JAMAIS et l'échec
        // était totalement silencieux — c'est ce qui l'a laissée morte sur 15 fiches.
        // On vise alors le bouton d'achat lui-même, qui existe sur toute fiche vendable.
        const anchor =
          document.getElementById(this.dataset.anchor) ||
          document.querySelector('.product-form__submit');
        // La barre n'apparaît qu'une fois le client SORTI du haut de fiche — la section
        // main-product entière : galerie, zone d'achat, offre duo/pack, réassurance, atouts.
        // Elle se déclenchait sur l'ancre elle-même, posée AVANT les variantes : au moment où
        // elle surgissait, le vrai bouton d'achat, « Ajouter le duo » et son propre sélecteur
        // de taille étaient encore à l'écran — quatre façons d'acheter sur un seul écran.
        // Elle se retire dès qu'on remonte dans le haut de fiche, où le bouton est visible.
        const cible = anchor ? anchor.closest('.shopify-section') || anchor : null;
        if (cible) {
          this.io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', show);
              // Pour le badge hCaptcha (voir la feuille de style) : la barre est-elle là, et
              // quelle hauteur fait-elle (zone sûre iOS comprise) ?
              document.body.classList.toggle('pelux-barre-visible', show);
              if (show) document.body.style.setProperty('--pelux-barre-h', this.offsetHeight + 'px');
              // La couleur ne peut changer que dans le haut de fiche, là où la barre est
              // cachée : la resynchroniser à chaque apparition suffit à la garder juste.
              if (show && this.majVignette) this.majVignette();
            },
            { threshold: 0 }
          );
          this.io.observe(cible);
        }
        if (this.hasAttribute('data-inline-atc')) {
          this.initInlineAtc();
        }
        this.initPriceMirror();
      }

      // Recopie le prix de la buybox dans la barre, sur les seuls produits à prix
      // variable. La buybox est re-rendue par la Section Rendering API à chaque
      // changement de variante ; la barre, elle, vit dans une autre section et ne
      // l'était pas — d'où un prix figé sur la variante la moins chère.
      // Tout échec est silencieux PAR CONSTRUCTION : le Liquid a déjà écrit
      // « À partir de X », qui reste vrai. On n'affiche jamais un prix faux.
      initPriceMirror() {
        const cible = this.querySelector('[data-mirror-price]');
        if (!cible) return;
        const bloc = document.querySelector('[id^="price-"][role="status"]');
        if (!bloc) return;

        const lire = () => {
          const enPromo = bloc.querySelector('.price--on-sale');
          const prix = bloc.querySelector(
            enPromo ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'
          );
          const texte = prix && prix.textContent.trim();
          if (texte) cible.textContent = texte;
        };

        lire();
        this.mo = new MutationObserver(lire);
        this.mo.observe(bloc, { childList: true, subtree: true, characterData: true });
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        if (this.suivreTaille) document.removeEventListener('change', this.suivreTaille);
        document.body.classList.remove('pelux-barre-visible');
      }

      initInlineAtc() {
        const dataEl = this.querySelector('[data-sticky-variants]');
        if (!dataEl) return;
        let variants;
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        const byId = {};
        variants.forEach((v) => {
          byId[v.id] = v;
        });
        const sizeBtns = Array.from(this.querySelectorAll('.pelux-sticky__size'));
        const addBtn = this.querySelector('[data-sticky-add]');
        const anchor = this.dataset.anchor;
        let selectedSize = null;

        // Sans pastilles (réglage sans_tailles, harnais) : la variante qui part est celle du
        // formulaire du haut (couleur et taille). Tant que la fiche attend un choix de taille
        // (« Aucune taille cochée à l'arrivée »), le bouton y ramène au lieu d'ajouter.
        const sansTailles = this.hasAttribute('data-sans-tailles');
        const formulaireDuHaut = () => {
          const vs = document.querySelector('variant-selects[data-section]');
          return vs ? document.getElementById('product-form-' + vs.dataset.section) : null;
        };
        const varianteDuHaut = () => {
          const form = formulaireDuHaut();
          const input = form && form.querySelector('[name="id"]');
          return (input && byId[input.value]) || null;
        };
        const tailleAttendue = () => {
          const form = formulaireDuHaut();
          const pf = form && form.closest('product-form');
          return !!(pf && pf.classList.contains('pelux-taille-a-choisir'));
        };

        const currentColor = () => {
          const input = document.querySelector(
            'form[data-type="add-to-cart-form"] [name="id"], product-info [name="id"], [name="id"]'
          );
          const cur = input && byId[input.value];
          return cur ? cur.c : variants[0] && variants[0].c;
        };
        const targetVariant = () => {
          if (sansTailles) return tailleAttendue() ? null : varianteDuHaut();
          if (!selectedSize) return null;
          const c = currentColor();
          return variants.find((v) => v.c === c && v.s === selectedSize) || null;
        };
        const refresh = () => {
          const t = targetVariant();
          const choisie = sansTailles || !!selectedSize;
          if (choisie && t && t.av) {
            addBtn.textContent = addBtn.dataset.labelAdd;
          } else if (choisie && t && !t.av) {
            addBtn.textContent = 'Indisponible';
          } else {
            addBtn.textContent = addBtn.dataset.labelChoose;
          }
        };

        // Miniature de la variante : image et nom de la couleur courante, et un toucher qui
        // ramène au choix de couleur du haut de fiche (pas de sélecteur dans la barre).
        const vignette = this.querySelector('[data-sticky-vignette]');
        if (vignette) {
          const img = vignette.querySelector('img');
          const nom = this.querySelector('[data-sticky-couleur-nom]');
          this.majVignette = () => {
            const input = document.querySelector(
              'form[data-type="add-to-cart-form"] [name="id"], product-info [name="id"], [name="id"]'
            );
            const v = (input && byId[input.value]) || variants[0];
            if (!v) return;
            if (v.img && img && img.getAttribute('src') !== v.img) img.setAttribute('src', v.img);
            // Sans pastilles : la taille qui part se lit à côté de la couleur (« Bleu · M »).
            if (nom && v.c) nom.textContent = sansTailles && v.s && !tailleAttendue() ? v.c + ' · ' + v.s : v.c;
            vignette.setAttribute('aria-label', 'Couleur : ' + v.c + '. Changer de couleur');
          };
          this.majVignette();
          document.addEventListener('change', (e) => {
            if (e.target && e.target.name === 'id') this.majVignette();
          });
          vignette.addEventListener('click', () => {
            const index = parseInt(this.dataset.couleurIndex, 10) || 0;
            const choix =
              document.querySelectorAll('variant-selects .product-form__input')[index] ||
              document.querySelector('variant-selects');
            if (choix) choix.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }

        sizeBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            selectedSize = btn.dataset.size;
            sizeBtns.forEach((b) => {
              const on = b === btn;
              b.classList.toggle('is-selected', on);
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            refresh();
          });
        });

        // Taille cochée à l'arrivée (réglage du bloc Variantes, marqueur data-pelux-taille-defaut ;
        // harnais) : la barre reprend la taille du formulaire du haut — M d'office, puis celle que
        // le client y choisit. Une taille touchée ici tient jusqu'au prochain changement de taille
        // en haut de fiche. Sans ce réglage, rien ne change : la taille se choisit dans la barre.
        const tailleDuHaut = () => {
          const vs = document.querySelector('variant-selects[data-pelux-taille-defaut]');
          const form = vs && document.getElementById('product-form-' + vs.dataset.section);
          const input = form && form.querySelector('[name="id"]');
          const v = input && byId[input.value];
          return v ? v.s : null;
        };
        const marquer = (taille) => {
          if (!sizeBtns.some((b) => b.dataset.size === taille)) return;
          selectedSize = taille;
          sizeBtns.forEach((b) => {
            const on = b.dataset.size === taille;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          refresh();
        };
        let tailleHaut = tailleDuHaut();
        if (tailleHaut) marquer(tailleHaut);
        this.suivreTaille = (e) => {
          if (!e.target || e.target.name !== 'id') return;
          if (sansTailles) {
            refresh();
            return;
          }
          const t = tailleDuHaut();
          if (t && t !== tailleHaut) {
            tailleHaut = t;
            marquer(t);
          }
        };
        document.addEventListener('change', this.suivreTaille);

        addBtn.addEventListener('click', () => {
          const t = targetVariant();
          if (!t || !t.av) {
            // Sans taille choisie (ou indisponible) : comportement actuel = scroll vers la buybox.
            // Même repli que dans connectedCallback : sans ancre, on vise le bouton d'achat.
            const el =
              document.getElementById(anchor) || document.querySelector('.product-form__submit');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          this.addToCart(t.id, addBtn);
        });

        refresh();
      }

      addToCart(id, addBtn) {
        addBtn.setAttribute('disabled', '');
        const drawer = document.querySelector('cart-drawer');
        const sections =
          drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: id, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((res) => {
            addBtn.removeAttribute('disabled');
            if (res && res.status) return; // erreur d'ajout
            if (drawer && res && res.sections && drawer.renderContents) {
              drawer.renderContents(res);
            } else {
              window.location = root + 'cart';
            }
          })
          .catch(() => {
            addBtn.removeAttribute('disabled');
          });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
